module.exports = __webpack_public_path__ + "img/classroom_3.e0a1dbc8.jpg";